/**
 * Public layout fetcher.
 *
 * 0.36.293 — One round-trip to /api/layout returns both header and
 * footer configs. The citizen-side <Header> and <Footer> use this on
 * mount via the LayoutConfigContext.
 */
const BASE = import.meta.env.VITE_API_BASE_URL || '';

export async function fetchPlatformLayouts() {
  const res = await fetch(`${BASE}/api/layout`, { credentials: 'include' });
  if (!res.ok) throw new Error(`HTTP ${res.status} fetching /api/layout`);
  return res.json();
}
